import React, { useRef } from 'react'
import { ARCHIVED_NOTES } from 'data/filters/types'
import { useArchivedDrop } from './useArchivedDrop'
import { ExpandableRowLayout } from '../ExpandableRowLayout'

const ArchivesIcon = ARCHIVED_NOTES.get('icon')

export const ARCHIVED_SECTION_ID = 'archived-section-id'

export type ArchivesIconProps = {
  isActive: boolean
  isExpanded: boolean
  onToggleExpand: (
    filterId: string,
    options?: { collapseChannels?: boolean }
  ) => void
}

const icon = <ArchivesIcon size={14} />

export function ArchivedFilter({
  isActive,
  isExpanded,
  onToggleExpand,
}: ArchivesIconProps) {
  const layoutRef = useRef<HTMLAnchorElement>(null)
  const isDragOver = useArchivedDrop(ARCHIVED_SECTION_ID, layoutRef)

  return (
    <ExpandableRowLayout
      id={ARCHIVED_SECTION_ID}
      ref={layoutRef}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      hideChevron
      depth={0}
      icon={icon}
      label={ARCHIVED_NOTES.get('name')}
      isActive={isActive}
      isDragOver={isDragOver}
      hoverZone={isDragOver ? 'middle' : undefined}
      sticky
    />
  )
}
